<ion-card class="order-card" [ngClass]="orderStatusModification" *ngIf="!isSubscription">
  <ion-card-header class="order-card-header" color="dark">
    <ion-card-title class="order-card-header__wrapper">
      <ion-label class="order-card-header__title">{{orderNumber}}{{orderDate}}</ion-label>
      <ion-text class="order-card-header__status">
        {{orderStatus.formattedStatus}}
        <span *ngIf="isInProgressCustomerOrder && !hideETA">&#160;- ETA
          {{orderStatus.prepTimeDuration ? orderStatus.prepTimeDuration : estimatedTimeInMinutes + ' min'}}
        </span>
      </ion-text>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="order-card__content">
    <app-cart-item *ngFor="let item of orderStatus.lineItems" [item]="item" [hasDelete]="false" [serviceChargeName]="serviceChargeName"
                   [hasPrice]="belongToCustomer" [transparent]="true" [currencySign]="currencySign"></app-cart-item>
  </ion-card-content>
</ion-card>

<ion-card class="order-card order-card--brand" *ngIf="isSubscription">
  <ion-card-header class="order-card-header" color="dark">
    <ion-card-title class="order-card-header__wrapper">
      <ion-label class="order-card-header__title">{{subscriptionTitle}}</ion-label>
      <ion-text class="order-card-header__cancel" (click)="cancelSubscription(subscriptionOrderStatus.id)">cancel</ion-text>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="order-card__content">
    <app-cart-item *ngFor="let item of subscriptionOrderStatus.lineItems" [item]="item" [hasDelete]="false" [serviceChargeName]="serviceChargeName"
                   [hasPrice]="false" [transparent]="true" [currencySign]="currencySign"></app-cart-item>
  </ion-card-content>
</ion-card>
